import GenericApp from "../generic/GenericApp";
import PlusCareLogo from "./components/PlusCareLogo";
import "./PlusCareApp.scss";
import PlusCareHome from "./pages/PlusCareHome";
import PlusCareFooter from "./components/PlusCareFooter";

export default function PlusCareApp() {
    return <GenericApp logo={<PlusCareLogo />} hidePoweredBy home={<PlusCareHome />} footer={PlusCareFooter} />;
}
